import {
  CountryAlpha2,
  useGetStructuresByCountryQuery
} from 'generated/graphql'
import { ICustomFieldComponentProps } from 'types'
import { ControlledSelect } from 'components/ControlledFields'
import { GeneralInformationForm } from 'pages/Onboarding/OnboardingRegion/UsRegion/UsRegionStepsConfigs/GeneralInformation/general-information-schema'

type BusinessStructureProps = ICustomFieldComponentProps<
  GeneralInformationForm,
  'businessStructureDetails.businessStructure'
>

export const BusinessStructure = ({
  name,
  label,
  disabled,
  placeholder
}: BusinessStructureProps) => {
  const { data, loading } = useGetStructuresByCountryQuery({
    variables: { input: { countryAlpha2: CountryAlpha2.Us } }
  })

  const options =
    data?.structuresByCountry?.structures?.map(structure => ({
      value: structure.key,
      label: structure.name ?? structure.key
    })) ?? []

  return (
    <ControlledSelect
      name={name}
      label={label}
      options={options}
      placeholder={placeholder}
      disabled={disabled}
      isLoading={loading}
    />
  )
}
